// import { apihost } from '@/api/urls';
import axios, { AxiosResponse } from 'axios';
import AuthService from '@/services/AuthService';
import qs from 'qs';

const auth = new AuthService();

axios.interceptors.request.use(
  (config) => {
    return auth.getUser().then((user) => {
      if (user) {
        config.headers.Authorization = `Bearer ${user.access_token}`;
      }

      return config;
    });
  },

  (error) => {
    return Promise.reject(error);
  },
);

axios.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    console.log(error);
    if (error.response.status === 401) {
      auth.login();
    }

    return Promise.reject(error);
  },
);

const get = (url: string, apihost: string) => {
  return axios.get(`${apihost}${url}`);
};

const getParams = (url: string, apihost: string, params: any) => {
  return axios.get(`${apihost}${url}`, {
    params,
    paramsSerializer: (p: any) => qs.stringify(p, { arrayFormat: 'repeat' }),
  });
};

const put = (url: string, apihost: string, json: any) => {
  return axios.put(`${apihost}${url}`, json);
};

const del = (url: string, apihost: string) => {
  return axios.delete(`${apihost}${url}`);
};

const post = (url: string, apihost: string, json: any) => {
  return axios.post(`${apihost}${url}`, json);
};

const getFile = (url: string, apihost: string) => {
  return auth.getUser().then((user) => {
    const headers: any = {};
    if (user) {
      headers.Authorization = `Bearer ${user.access_token}`;
    }
    return fetch(`${apihost}${url}`, { headers });
  }).then((response) => {
    if (response.status === 401) {
      auth.login();
      return Promise.reject(new Error('401 Unauthorized'));
    }
    if (!response.ok) {
      return Promise.reject(new Error(`HTTP ${response.status}`));
    }

    const reader = (response.body as ReadableStream<Uint8Array>).getReader();
    const chunks: Uint8Array[] = [];
    let totalBytes = 0;

    const read = (): Promise<{ data: Blob }> => {
      return Promise.race([
        reader.read(),
        new Promise<never>((_, reject) =>
          setTimeout(() => reject('STREAM_TIMEOUT'), 5000),
        ),
      ])
        .then(({ done, value }) => {
          if (done) {
            return { data: new Blob(chunks) };
          }
          if (value) {
            chunks.push(value);
            totalBytes += value.length;
          }
          return read();
        })
        .catch((err) => {
          if (err === 'STREAM_TIMEOUT' && totalBytes > 0) {
            reader.cancel();
            return { data: new Blob(chunks) };
          }
          throw err;
        });
    };

    return read();
  });
};

export const apiCaller = {
  get,
  put,
  post,
  del,
  getFile,
  getParams,
};
